import { Box, styled } from '@mui/material'

export const AvatarContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  height: '200px',
  width: '200px',
  borderRadius: '12px',
  overflow: 'hidden',
  flexShrink: 0,
  marginBottom: theme.spacing(2),
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.up('sm')]: {
    height: '222px',
    width: '222px',
    marginRight: theme.spacing(4),
    marginBottom: 0,
    marginLeft: 0,
  },
  [theme.breakpoints.up('md')]: {
    height: '250px',
    width: '250px',
  },
  [theme.breakpoints.up('lg')]: {
    height: '318px',
    width: '318px',
  },
}))
